import { Suspense } from 'react';
import './App.css';
import FiveCanvas from './components/Five/FiveCanvas';
import SceneCanvas from './components/Four/SceneCanvas';
import MobCanvas from './components/Mobile/MobCanvas';
import FlexCanvas from './components/Three/Canvas/FlexCanvas';
import { ScreenProvider } from './context/ScreenCtx';


export default function App() {
  return (
    <>
      <ScreenProvider>
        <Suspense fallback={<h1>Loading.. </h1>}>
          <main>
            {/* <MobCanvas /> */}
            {/* <SceneCanvas /> */}
            <FlexCanvas />
            {/* <FiveCanvas /> */}
          </main>
        </Suspense>
      </ScreenProvider>
    </>
  )
}
